/**
 * labrules.mjs — the lab-access decision, as pure functions of a declaration.
 *
 * Separate from labaccess.jsx for one reason: it imports React and the browser identity
 * module, so a Node gate cannot load it, and a gate that reimplements the rule in order to test it
 * is testing a copy. Everything here takes the declaration as an argument and touches nothing else,
 * so gate-lab-access.mjs exercises the SAME code the browser runs.
 */

/** The declared row for a (level, chapter), or null. */
export function labFor(decl, level, chapter) {
  const lvl = String(level || '').toUpperCase();
  const n = Number(chapter);
  if (!Number.isFinite(n)) return null;
  return (decl?.labs || []).find(
    (l) => String(l.level).toUpperCase() === lvl && Number(l.chapter) === n) || null;
}

/**
 * Has the founder declared this ladder SEVA?
 *
 * FP-020. The register is a SEPARATE argument, not a field of the lab declaration, because seva is a
 * property of a LADDER and not of a lab — a ladder cannot be charitable in its labs and commercial in
 * its chapters. The same file backs the server's content gate, so both answers come from one ruling.
 *
 * Consulted in the running decision and not only in the gate: a gate runs when someone runs it, this
 * runs on every render, and a careless edit to an access row must not be able to put a charitable
 * surface behind enrolment in between two gate runs.
 */
export const isSeva = (seva, level) =>
  (seva?.levels || []).map((s) => String(s).toUpperCase())
    .includes(String(level || '').toUpperCase());

/** 'free' | 'enrolled' | null. A seva ladder resolves to 'free' whatever its row says. */
export function labAccess(decl, seva, level, chapter) {
  const row = labFor(decl, level, chapter);
  if (!row) return null;
  if (isSeva(seva, level)) return 'free';
  return row.access === 'enrolled' ? 'enrolled' : 'free';
}

export const ACCESS_VALUES = Object.freeze(['free', 'enrolled']);
